import React from 'react';
import { Form, Button, Row, Col } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Meteor } from 'meteor/meteor';
import { Roles } from 'meteor/alanning:roles';
import { isEmpty } from 'lodash';
import methodPromise from '../../../modules/method-promise-wrapper';
import handleErrorInClient from '../../../modules/handle-error-in-client';

const AIConfiguration = () => {
  const [settings, setSettings] = React.useState({});
  const [editmode, setEditmode] = React.useState(false);
  const userId = Meteor.userId();
  const isAdmin = Roles.userIsInRole(userId, 'admin');
  const fetchSettings = async () => {
    try {
      const AISettings = await methodPromise('admin.fetchAISetting');
      if (AISettings.length > 0) {
        setSettings(AISettings[0]);
      } else {
        setSettings({
          Resolution: 0,
          LimitSueface: 0,
          LayerName: '',
          ServiceType: '',
          value: true,
          URL: '',
          BatchSize: 32,
          StepPerEpoch: 20,
          ValidationStep: 100
        });
      }
    } catch (error) {
      handleErrorInClient(error);
    }
  };
  React.useEffect(() => {
    fetchSettings();
  }, []);
  const handleSubmit = async event => {
    // event.preventDefault();
    let method = '';
    if (settings.value === true) {
      method = 'admin.addAISetting';
    } else {
      method = 'admin.updateAISetting';
    }

    const setting = {
      _id: settings._id,
      Resolution: event.target.Resolution.value,
      LimitSueface: event.target.LimitSueface.value,
      LayerName: event.target.LayerName.value,
      ServiceType: event.target.ServiceType.value,
      value: false,
      URL: event.target.URL.value,
      BatchSize: event.target.BatchSize.value,
      StepPerEpoch: event.target.StepEpoch.value,
      ValidationStep: event.target.ValidationStep.value
    };
    try {
      await methodPromise(method, setting);
      setSettings(setting);
    } catch (error) {
      handleErrorInClient(error);
    }
  };
  const Edit = () => {
    setEditmode(!editmode);
  };
  const Cancel = () => {
    setEditmode(!editmode);
    Window.location.reload();
    return false;
  };
  if (!isEmpty(settings)) {
    return (
      <Form onSubmit={handleSubmit}>
        <Row>
          <Col xs={12} md={6} lg={4}>
            <Form.Group>
              <Form.Label>Surface Limit in hectares</Form.Label>
              <Form.Control
                disabled={!editmode}
                type="number"
                min={0}
                max={10000000}
                defaultValue={settings.LimitSueface}
                step={1}
                precision={2}
                name="LimitSueface"
              />
            </Form.Group>
            <Form.Group>
              <Form.Label>Resolución de salida en metros</Form.Label>
              <Form.Control
                disabled={!editmode}
                type="number"
                min={0}
                max={1}
                step={0.05}
                precision={2}
                defaultValue={settings.Resolution}
                name="Resolution"
                // value={0.2}
              />
            </Form.Group>
            <Form.Group>
              <Form.Label>Layer Name</Form.Label>
              <Form.Control
                disabled={!editmode}
                type="text"
                name="LayerName"
                placeholder="Layer Name"
                defaultValue={settings.LayerName}
              />
            </Form.Group>
            <Form.Group>
              <Form.Label>URL del servicio</Form.Label>
              <Form.Control
                disabled={!editmode}
                type="text"
                name="URL"
                placeholder="Where is your service?"
                defaultValue={settings.URL}
              />
            </Form.Group>
            <Form.Group>
              <Form.Label>Service Type</Form.Label>
              <Form.Control
                disabled={!editmode}
                as="select"
                name="ServiceType"
                placeholder="Service Type"
                defaultValue={settings.ServiceType}
                default
              >
                <option value="">-</option>
                <option value="WMS">WMS</option>
                <option value="LOCAL">LOCAL</option>
                <option value="TMS">TMS</option>
              </Form.Control>
            </Form.Group>
            <Form.Group>
              <Form.Label>Batch Size</Form.Label>
              <Form.Control
                disabled={!editmode}
                type="number"
                min={0}
                max={100}
                step={1}
                defaultValue={settings.BatchSize}
                name="BatchSize"
                // value={0.2}
              />
            </Form.Group>
            <Form.Group>
              <Form.Label>Step Per Epoch</Form.Label>
              <Form.Control
                disabled={!editmode}
                type="number"
                min={0}
                max={1000}
                defaultValue={settings.StepPerEpoch}
                name="StepEpoch"
                // value={0.2}
              />
            </Form.Group>
            <Form.Group>
              <Form.Label>Validation Step</Form.Label>
              <Form.Control
                disabled={!editmode}
                type="number"
                min={0}
                max={1000}
                step={1}
                defaultValue={settings.ValidationStep}
                name="ValidationStep"
                // value={0.2}
              />
            </Form.Group>
          </Col>
        </Row>
        <br />
        {isAdmin ? (
          <Form.Row className="d-flex">
            <Button disabled={editmode} variant="primary" onClick={Edit}>
              <FontAwesomeIcon icon="edit" size="lg" />{' '}
              {settings.value ? 'Add Setting' : 'Edit Setting'}
            </Button>
            <Button disabled={!editmode} type="submit" variant="success">
              <FontAwesomeIcon icon="save" size="lg" /> Save
            </Button>
            <Button disabled={!editmode} variant="danger" onClick={Cancel}>
              <FontAwesomeIcon icon="times" size="lg" /> Cancel
            </Button>
          </Form.Row>
        ) : (
          <> </>
        )}
      </Form>
    );
  }
  return <></>;
};

export default AIConfiguration;
